import React from 'react'
import { SponsorForm } from './sponsor'
import { CustomerForm } from './customer'
import { EmployeeForm } from './employee'
import { WalkinForm } from './walkin'
import { hot } from 'react-hot-loader/root'

const Form = (props) => {
  switch (props.terminal) {
    case 'customer':
      return (
        <CustomerForm {...props} />
      )

    case 'employee':
      return (
        <EmployeeForm {...props} />
      )

    case 'sponsor':
      return (
        <SponsorForm {...props} />
      )

    case 'walkin':
      return (
        <WalkinForm {...props} />
      )
  }
}

export default hot(Form)
